import { render, staticRenderFns } from "./Gold.vue?vue&type=template&id=636434c2&scoped=true&"
import script from "./Gold.vue?vue&type=script&lang=js&"
export * from "./Gold.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "636434c2",
  null
  
)

export default component.exports